<template>
    <q-list no-border link inset-separator class="v-menu" v-if="user">
        <q-list-header class="q-pr-lg text-center q-my-md">
            <img src="../../img/iqos-grey.svg" width="70%"/>
        </q-list-header>
        <template v-for="rootItem in menuItems">
            <q-item v-if="!rootItem.children && (!rootItem.role || canISeeThis(rootItem, rootItem.role))"
                    item exact :to="{ name: rootItem.route }" :dusk="rootItem.label">
                <q-item-side :icon="rootItem.icon"/>
                <q-item-main :label="$T(rootItem.label)"/>
            </q-item>
            <q-collapsible v-else-if="!rootItem.role || ( rootItem.role === user.role.name && canISeeThis(rootItem, rootItem.role)) "
                           :group="groupId"
                           :icon="rootItem.icon" :label="$T(rootItem.label)">
                <q-item v-for="item in rootItem.children" :key="item.label"
                        v-if="!item.role || canISeeThis(item, item.role)"
                        class="circle"
                        :dusk="item.label"
                        item exact :to="{ name: item.route }">
                    <q-item-side :icon="item.icon"/>
                    <q-item-main :label="$T(item.label)"/>
                </q-item>
            </q-collapsible>
        </template>
    </q-list>
</template>

<script>
    import {mapGetters} from 'vuex'
    import menuItems from '../menuItems'

    import {
        uid,
        QList,
        QListHeader,
        QCollapsible,
        QItem,
        QItemSide,
        QItemMain
    } from 'quasar-framework'

    export default {
        mixins: [menuItems],
        components: {
            QList,
            QListHeader,
            QCollapsible,
            QItem,
            QItemSide,
            QItemMain
        },

        computed: {
            ...mapGetters({
                user: 'auth/user'
            }),

            routeCreateOrder(){
                return this.user.role.name.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-') + '.order'
            }
        },

        data() {
            return {
                groupId: uid()
            }
        },

        methods: {
            canISeeThis(menu, role) {

                if(this.routeCreateOrder === menu.route){
                    return this.user.enableCreateOrder;
                }
              
                if( menu.hasOwnProperty('lendingPointRole') ) {
                    return (this.user.lending_point && this.user.lending_point.lending_point_type.description === menu.lendingPointRole) && (this.matchRole(this.user.role.name, role))
                }else if(menu.hasOwnProperty('mustBeActiveHostless') && role == this.user.role.nome ){
                    return ['Lending Point Hostesses'].includes(this.user.role.name)
                }else if (menu.hasOwnProperty('mustBeActive') && role == this.user.role.nome ) {
                    if (menu.hasOwnProperty('mustBeReserveAllowed')) {
                        return (this.user.lending_point && !this.user.lending_point.no_reserve_allowed && this.user.lending_point.active && this.matchRoleLendingPoint(this.user.role.name))
                    }
                    return (this.user.lending_point && this.user.lending_point.active && this.matchRoleLendingPoint(this.user.role.name))
                }  else {

                    if( menu.hasOwnProperty('prod_env') ) {
                      if (menu.prod_env && this.matchRole(this.user.role.name, role)) {
                        return true
                      }
                    }
                    return this.matchRole(this.user.role.name, role)
                }
              },

              matchRole(needle, haystack) {
                return haystack instanceof Array ?
                    haystack.includes(needle) :
                    haystack == needle
              },

              matchRoleLendingPoint(userRole) {
                return ['Lending Point', 'Lending Point Indirect'].includes(userRole)
              }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Menu.vue